module.exports = __webpack_public_path__ + "img/__icon_NISKOPODŁOGOWY.6b5c110c.svg";